export const firebaseConfig = {
apiKey: "AIzaSyA3gq7ATAScDY7ab7qyAywy9cgFpzq4w1U",authDomain: "pruforce-fc8b8.firebaseapp.com",projectId: "pruforce-fc8b8",storageBucket: "pruforce-fc8b8.appspot.com",messagingSenderId: "618021898898",appId: "1:618021898898:web:105d051ff8b1bc5b18f44b",measurementId: "G-0QYXFQNG5E"

};
